import htmlComponent from 'htmlcomponent'

export default function(dom, opts) {
	let options = {
        navSecondLevelCls: 'nav-main__subnav-item',
		...opts
	};

	const desktopWidth = 1024;

	const baseClass = 'collapsible';

	const trigger = dom.querySelector(`.${baseClass}__trigger`);
	const content = dom.querySelector(`.${baseClass}__content`);
	const baseClassSelector = dom.querySelector(`.${baseClass}`);
	const contentTransition = e => {
		content.removeEventListener('transitionend', contentTransition);
		content.style.maxHeight = '';
	};

	if (!dom.classList.contains(`${baseClass}--collapsed`) && window.innerWidth < desktopWidth && !dom.classList.contains(options.navSecondLevelCls)) {
		dom.classList.add(`${baseClass}--collapsed`);
	}

        trigger && content && trigger.addEventListener('click', e => {
            const closestLi = trigger.closest('li');

            if (closestLi && closestLi.classList.contains('nav-main__subnav-item') && window.innerWidth > desktopWidth) {
                window.location.href = trigger.getAttribute('href');
            } else {
                e.preventDefault();

                content.removeEventListener('transitionend', contentTransition);
                content.addEventListener('transitionend', contentTransition);

                content.style.maxHeight = `${content.scrollHeight}px`;

                setTimeout(() => {
                    dom.classList.toggle(`${baseClass}--collapsed`);
                }, 25);

                return false;
            }

        });

}
